import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectEditorMoveNode,
  selectHighlightedEdges,
} from '../map/slice/mapSelectors';
import { generateColor, setLuminosity, setSaturation } from '../utils/colors';
import { edgeToGeoJson, PropertyExtractor } from '../utils/geoJsonUtils';
import { Theme, useTheme } from '../helpers/hooks';
import { Edge } from '../types';
import { selectShowEdgeDirections } from '../plotter/plotterSelectors';
import { useMapLayer } from '../hooks/useMapLayer';

const getEdgeStyle = () => [
  {
    filter: ['==', ['get', 'head'], 1],
    style: {
      'shape-points': 3,
      'shape-radius': 12,
      'shape-fill-color': ['get', 'color'],
      'shape-stroke-color': ['get', 'color'],
      'shape-stroke-width': 4,
      'shape-rotate-with-view': false,
      'shape-displacement': [0, 0],
      'shape-angle': ['get', 'angle'],
      // 'shape-opacity': 0.3,
      // opacity: 0.3,
    },
  },
  {
    filter: ['==', ['get', 'head'], 0],
    style: {
      'stroke-width': 12,
      'stroke-color': ['get', 'color'],
      'stroke-line-cap': 'round',
      'stroke-line-join': 'round',
      // 'stroke-opacity': 0.3,
      // opacity: 0.3,
    },
  },
];

const highlightColor = (baseColor: string, theme: Theme) => {
  if (theme === 'light') {
    return setSaturation(setLuminosity(baseColor, 55), 60);
  } else if (theme === 'dark') {
    return setSaturation(setLuminosity(baseColor, 55), 60);
  }
  return baseColor; // Placeholder implementation
};

const extractGeoJsonProps: PropertyExtractor<Edge> = (
  edge,
  _arrowHead,
  theme,
) => {
  const baseColor =
    theme === 'light'
      ? generateColor(edge.tsp_id || 0)
      : generateColor(edge.tsp_id || 0, 50, 40);
  const color = highlightColor(baseColor, theme);
  return {
    key: `edge-${edge.id}`,
    id: edge.id,
    color,
  };
};

export const MapHighlights = ({ zIndex = 1 }) => {
  const edges = useSelector(selectHighlightedEdges);
  const showEdgeDirections = useSelector(selectShowEdgeDirections);
  const editorMoveNode = useSelector(selectEditorMoveNode);
  // const highlight = useSelector(selectHighlightOptions);

  const [theme] = useTheme();

  const features = useMemo(() => {
    return Object.values(edges)
      .filter((edge) => {
        if (edge?.positions?.length < 2) {
          return false;
        }
        return true;
      })
      .flatMap((edge) =>
        edgeToGeoJson(edge, extractGeoJsonProps, showEdgeDirections, {}, theme),
      );
  }, [edges, showEdgeDirections, theme, editorMoveNode]);

  const layerStyle = useMemo(() => {
    return getEdgeStyle();
  }, []);

  useMapLayer(features, { zIndex, style: layerStyle, opacity: 0.5 });

  return <></>;
};
